import { toast } from "sonner";

export const copyText = async (value, label = "Copied") => {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(label);
  } catch {
    const el = Object.assign(document.createElement("textarea"), { value, readOnly: true });
    el.style.cssText = "position:fixed;opacity:0";
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand("copy");
    el.remove();
    ok ? toast.success(label) : toast.error("Couldn't copy — select the text and copy it manually");
  }
};
